<card name="Receipts">
  <div card content>
    <table-receipt></table-receipt>
  </div>
</card>
